export default function redirectURLChecker(
  redirecturl: string,
  newParams: Record<string, string>
) {
  // Decode the URL if it is encoded
  redirecturl = decodeURIComponent(redirecturl);

  // Parse the URL and its query parameters
  const url = new URL(redirecturl);
  const urlParams = new URLSearchParams(url.search);

  // Add new parameters if provided
  if (newParams && typeof newParams === 'object') {
    Object.keys(newParams).forEach((key) => {
      urlParams.set(key, newParams[key]);
    });
  }

  // Set the updated search parameters back to the URL
  url.search = urlParams.toString();

  return url;
}

// 🔄 NEW: Enhanced redirect URI handling for dynamic redirects
export function getDynamicRedirectUri(
  primaryRedirect?: string,
  fallbackRedirect?: string,
  defaultRedirect: string = 'https://infineon-staging-livebench.tenxerlabs.com'
): string {
  // Priority order: primary > fallback > default
  let finalRedirect = primaryRedirect || fallbackRedirect || defaultRedirect;
  
  // Ensure the redirect URI is a valid URL
  if (finalRedirect && !finalRedirect.startsWith('http')) {
    // If it's just a domain like "tenxer.com", make it a full URL
    finalRedirect = `https://${finalRedirect}`;
  }
  
  return finalRedirect;
}

// 🔄 NEW: Extract redirect URI from multiple sources with priority
export function extractRedirectUri(
  searchParams: URLSearchParams,
  cookieName: string = 'infineon_redirect_uri'
): string | null {
  // 1. Try to get from cookie first (most reliable)
  if (typeof document !== 'undefined') {
    const cookieRedirectUri = document.cookie
      .split('; ')
      .find(row => row.startsWith(`${cookieName}=`))
      ?.split('=')[1];
    
    if (cookieRedirectUri) {
      return decodeURIComponent(cookieRedirectUri);
    }
  }
  
  // 2. Try URL parameters in priority order
  const redirectUri = searchParams.get('redirect_uri') || 
                     searchParams.get('redirecturl') || 
                     searchParams.get('redirectUri') ||
                     searchParams.get('originalRedirect') ||
                     searchParams.get('livebenchRedirect');
  
  return redirectUri;
}

// 🔄 NEW: Store redirect URI in cookie for preservation through auth flow
export function storeRedirectUri(
  redirectUri: string,
  cookieName: string = 'infineon_redirect_uri',
  maxAge: number = 300 // 5 minutes
): void {
  if (typeof document !== 'undefined') {
    const cookieValue = `${cookieName}=${encodeURIComponent(redirectUri)}; path=/; max-age=${maxAge}; SameSite=Lax`;
    document.cookie = cookieValue;
  }
}
